module.exports = __webpack_public_path__ + "img/close-maps-window.aca882bf.svg";